module.exports = __webpack_public_path__ + "img/kid-large.0c18fbab.svg";